import { IError } from '~src/httpClient/serverApi/types/IError';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { GetGroupsRequest, IGetGroupsParams, IGetGroupsResult } from '~src/ts/ServerApi/requests/GetGroupsRequest';
import { GetUsersRequest, IGetUsersParams, IGetUsersResult } from '~src/ts/ServerApi/requests/GetUsersRequest';
import { FilterOps, IStringValuedFilterClause } from '~src/ts/ServerApi/types/IFilterClause';
import { IGroup } from '~src/ts/ServerApi/types/IGroup';
import { IUserWithPublicInfo } from '~src/ts/ServerApi/types/IUser';

import { Recipient } from '../types/Recipient';

export function compareRecipients(a: Recipient, b: Recipient): number {
  const aName = a.kind === 'USER' ? a.displayName : a.name;
  const bName = b.kind === 'USER' ? b.displayName : b.name;
  return aName.toLocaleLowerCase().localeCompare(bName.toLocaleLowerCase());
}

export function searchUsers(searchTerm: string, maxItems: number): Promise<IUserWithPublicInfo[]> {
  const requestParams: IGetUsersParams = getUsersRequestParams(searchTerm, maxItems);
  const getUsersRequest = new GetUsersRequest(requestParams);

  // Request users from server
  return WebHttpClient.sendRequest(getUsersRequest)
    .then((result: IGetUsersResult) => {
      if (result.errors) {
        return Promise.reject(getErrorCodeFromErrors(result.errors));
      }
      return result.users;
    });
}

export function searchGroups(searchTerm: string, maxItems: number): Promise<IGroup[]> {
  const requestParams: IGetGroupsParams = getGroupsRequestParams(searchTerm, maxItems);
  const getGroupsRequest = new GetGroupsRequest(requestParams);

  // Request users from server
  return WebHttpClient.sendRequest(getGroupsRequest)
    .then((result: IGetGroupsResult) => {
      if (result.errors) {
        return Promise.reject(getErrorCodeFromErrors(result.errors));
      }
      return result.groups;
    });
}

function getGroupsRequestParams(nameQueryText: string, maxItems: number): IGetGroupsParams {
  return {
    filter: { operator: FilterOps.and, clauses: [{ operator: FilterOps.matches, value: nameQueryText } as IStringValuedFilterClause]},
    order: [{ascending: true, field: 'name'}],
    page: { startIndex: 0, maxItems: maxItems},
  };
}

function getUsersRequestParams(nameQueryText: string, maxItems: number): IGetUsersParams {
  return {
    filter: { operator: FilterOps.and, clauses: [{ operator: FilterOps.matches, value: nameQueryText } as IStringValuedFilterClause]},
    order: [{ascending: true, field: 'displayName'}],
    page: { startIndex: 0, maxItems: maxItems},
    includeGuestIfEnabled: false
  };
}

function getErrorCodeFromErrors(errors: IError[]): number | undefined {
  return (!!errors && errors.length > 0) ? errors[0].code : undefined;
}